import { style } from '@angular/animations';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ContactComponent } from '../contact/contact.component';
import { MoreInfoComponent } from '../more-info/more-info.component';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
})
export class MainComponent implements OnInit {

onView: boolean = false;
onCollapse: boolean = false;


more() {
  this.dialog.open(MoreInfoComponent)
}

contact() {
  // this.onCollapse = !this.onCollapse
  this.dialog.open(ContactComponent)
}

onClick() {
this.onView = !this.onView
}

@HostListener('window:resize', ['$event'])
onResize(event: Event) {
  this.checkScreenSize();
}

checkScreenSize() {
  if(window.innerWidth <= 425) {
    this.onView = true;
  }else {
    this.onView = false;
  }
}

  userDetails: { [key: string]: string } = {};
  constructor(
    private r: Router,
    public dialog: MatDialog,
    ) {}
  ngOnInit(): void {
    this.userDetails = JSON.parse(localStorage.getItem('user')!);
  }
  links = [
    {
      link: 'profile',
      title: 'Profile',
      icon: 'account_circle',
    },
    {
      link: 'dashboard',
      title: 'Dashboard',
      icon: 'dashboard',
    },
    {
      link: 'create-policy',
      title: 'Create Policy',
      icon: 'add_box',
    },
    {
      link: 'incomplete-transaction',
      title: 'Incomplete Bookings',
      icon: 'restore_page',
    },
    {
      link: 'completed-transactions',
      title: 'All Transactions',
      icon: 'list_alt',
    },
    {
      link: 'claims',
      title: 'Claims History',
      icon: 'donut_small',
    },
    // {
    //   link: 'request-edit',
    //   title: 'Edit Certificate',
    //   icon: 'edit',
    // },
    // {
    //   link: this.r.navigateByUrl('https://www.google.com'),
    //   title: 'More info',
    //   icon: 'info',
    // },
    
  ];
  logOut() {
    localStorage.clear()
    // localStorage.setItem('user','');
    // localStorage.setItem('wallet','');
    // localStorage.setItem('commission','');
    // localStorage.setItem('token','');
    this.r.navigateByUrl('signin');
  }
}
